import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import type { FormSpec } from '@/lib/form-specs';
import classes from './FieldEditor.module.css';

export interface FormSettingsPanelProps {
  spec: FormSpec;
  onDiscardChange: (discard: boolean) => void;
}

export function FormSettingsPanel({ spec, onDiscardChange }: FormSettingsPanelProps) {
  const { t } = useTranslation();
  const name = useId();
  const discard = spec.settings.discard_additional_fields === true;
  const hasFile = Object.values(spec.fields).some((f) => f.field === 'file');

  return (
    <div className={`${classes.panel} ${classes.formLevel}`}>
      <strong>{t('fields.formLevel')}</strong>
      <fieldset className={classes.fieldsetPlain}>
        <legend className={classes.legendPlain}>{t('fields.unlistedLegend')}</legend>
        <label className={classes.radioLine}>
          <input
            type="radio"
            name={name}
            checked={!discard}
            onChange={() => onDiscardChange(false)}
          />
          {t('fields.unlistedKeep')}
        </label>
        <label className={classes.radioLine}>
          <input
            type="radio"
            name={name}
            checked={discard}
            onChange={() => onDiscardChange(true)}
          />
          {t('fields.unlistedDrop')}
        </label>
      </fieldset>
      {Object.keys(spec.fields).length > 0 && (
        <span className={classes.rh}>
          {hasFile ? t('fields.uploadsAccepted') : t('fields.uploadsRefused')}
        </span>
      )}
    </div>
  );
}
